import React, {useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { FormControl, InputLabel, MenuItem, Select as MuiSelect, FormHelperText } from '@mui/material';

const filter = createFilterOptions();

// const useStyles = makeStyles(theme => ({
//     root: {
//         margin: theme.spacing(1),
//         // width: '90%',
//         display: 'flex',
//         '& .MuiOutlinedInput-input': {
//             padding: theme.spacing(1),
//             margin: theme.spacing(0.8), color:'#424448', fontWeight:700, letterSpacing:2
//         },
//         '& .MuiInputLabel-formControl': {
//             top: -9,
//             left: 45,
//         },
//         '& .MuiInputLabel-shrink': {
//             top: -6,
//             left: 0,fontSize:'1rem !important', fontStyle:'italic', color:'#899098'
//         },
//         '& #autocomplete':{
//           margin:0, padding:'4px 4px 4px 6px'
//         }
//     }
// }));

const AutocompleteSelect = (props) => {
    // const classes = useStyles();
    const [value, setValue] = React.useState(null);
    const { label, required=false, placeholder ,selectedType='title', duplicateCheck=false, error, className } = props;

    let items = [...props.items]; //Avoid if duplicate records
    if(items && items.length > 0){
      if(duplicateCheck){
        items = items.filter((v,i,a)=>a.findIndex(v2=>(v2.title===v.title))===i)
      }
    }    
    
    useEffect(() => {
      let val = props.value;
      if((items && items.length > 0)){
        if(val && selectedType && selectedType == 'id'){
          const temp = items.find((e) => (e[selectedType] && e[selectedType] == val)); //Search data by Id
          if(temp){
            val = temp['title']; 
          }
        }
      }else{
        val = (selectedType && selectedType == 'id') ? '' : val; 
      }
      setValue(val)
  }, [props.items, props.value]);

    return <FormControl className={className} required={required} {...(error && { error: true, helperText: error})}>
    <Autocomplete
    value={value}
    onChange={(event, newValue) => {
      if (typeof newValue === 'string') {
        setValue({
          title: newValue,
        });
        props.onChange({title: newValue,})
      } else if (newValue && newValue.inputValue) {
        // Create a new value from the user input
        setValue({
          title: newValue.inputValue,
        });
        props.onChange({title: newValue.inputValue,})
      } else {
        setValue(newValue);
        props.onChange(newValue)
      }
    }}
    filterOptions={(options, params) => {
      const filtered = filter(options, params);

      const { inputValue } = params;
      // Suggest the creation of a new value
      const isExisting = options.some((option) => inputValue === option.title);
      if (inputValue !== '' && !isExisting) {
        filtered.push({
          inputValue,
          title: `Add "${inputValue}"`,
        });
      }

      return filtered;
    }}
    selectOnFocus
    clearOnBlur
    handleHomeEndKeys
    id="autocomplete"
    options={items}
    getOptionLabel={(option) => {
      // Value selected with enter, right from the input
      if (typeof option === 'string') {
        return option;
      }
      // Add "xxx" option created dynamically
      if (option.inputValue) {
        return option.inputValue;
      }
      // Regular option
      return option.title;
    }}
    renderOption={(props, option) => <li {...props}>{option.title}</li>}
    freeSolo
    renderInput={(params) => (
      <TextField error={error} {...params} label={label} placeholder={placeholder} InputLabelProps={{ shrink: true }} />
    )}
  />
  {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>;
}

export default AutocompleteSelect;

